export function mapSampleOperator(node, ctx) {
    const exprNode = ctx.getChild(node, "Expression");
    if (!exprNode)
        return ctx.errorNode(node, "Sample missing count expression");
    const kindNode = ctx.getChild(node, "Identifier");
    return {
        type: "SampleOperator",
        count: ctx.mapScalarExpression(exprNode),
        kind: kindNode ? ctx.slice(kindNode) : undefined,
        start: node.from,
        end: node.to,
    };
}
